import { SkillVariableModel } from "@/common/models/skills";
import { AssignedTagModel } from "@/common/models/tags";
import { InteractionType } from "@/common/types";
import { MonitorTypes } from "@/repository/models/monitoring";
import { SentimentLabel } from "../../common/types/SentimentLabel";

export interface AgentInteractions {
	waiting?: InteractionDto[];
	active?: InteractionDto[];
}

export interface InteractionDto {
	id: string; //for call is scenarioId and for messaging is sessionId
	name: string;
	contactInformation: string;
	contactId?: string;
	description: string;
	startDate: string;
	firstAgentAssignedAt?: string;
	type: InteractionType;
	status: InteractionStatus;
	queuePriority: number;
	changeType: InteractionOperations;
	queueId: string;
	queueName: string;
	skills?: SkillVariableModel[];
	assignedTags?: AssignedTagModel[];
	firstAgentId?: string;
	internalMediaIdentificationName?: string;
	agentId?: string;
	agentName?: string;
	agentUpn?: string;
	direction: InteractionDirection;
	isEndedByAgent?: boolean;

	//messaging
	handlingStatus: InteractionHandlingStatus;
	isLastMessageSeen: boolean;
	emailTransferInitiatorId: string;

	//webchat
	agentCallingEnabled?: boolean;
	hasActiveVideoCall?: boolean;

	//generic
	externalUrl: string;

	//email
	entryPointEmail?: string;

	//call
	sessionId: string;
	isMonitoringEnabled?: boolean;
	isMonitoringStarted?: boolean;
	isSupervised?: boolean;
	isMonitoringHidden?: boolean;
	monitoringSupervisorId?: string;
	supervisorName?: string;
	monitoringType?: MonitorTypes;
	isOnHold?: boolean;
	isUnify?: boolean;

	//voicemail
	voicemailFilePath?: string;
	voicemailIsTranscriptionProcessed?: boolean;
	voicemailExpireDate?: Date;

	//transfer
	isIVRWarmTransfer: boolean;

	activeVariableText?: string;
	activeVariableTextIsAiGenerated?: boolean;
	offeringVariableText?: string;
	offeringVariableTextIsAiGenerated?: boolean;
	wasTransferred?: boolean;
	isHandledByAiAgent?: boolean;
	overallSentiment?: SentimentLabel | null;
}

export enum InteractionOperations {
	Added,
	Updated,
	Removed,
}

export enum InteractionStatus {
	Waiting = 0,
	Offering = 1,
	Assigned = 2,
	ColdTransferRinging = 3,
	ColdTransfer = 4,
	WarmTransferRinging = 5,
	WarmTransferInitialized = 6,
	WarmTransfer = 7,
	Parked = 8,
	Fallback = 9,
	CallTransferIVR = 10,
	CallbackRequest = 11,
	CallbackOffering = 12,
	Pause = 13,
}

export enum InteractionDirection {
	Incoming = 0,
	Outbound = 1,
}

export enum InteractionHandlingStatus {
	Active = 1,
	Waiting = 2,
}

export interface VoicemailTranscriptionFinished {
	id: string;
	transcription: string;
}

export enum TextSummaryStatus {
	Generated = 0,
	NotGenerated = 1,
}

export interface TextSummaryReadyNotification {
	sessionId: string;
	status: TextSummaryStatus;
	summary?: string;
}

export interface InteractionFilterData {
	queueIds: string[];
	types: string[];
}

export interface VoicemailOverviewDto {
	id?: string;
	expireDate?: Date;
	filePath?: string;
	isTranscriptionProcessed: boolean;
	transcription?: string;
}

export interface TranscriptionMessage {
	id: string;
	text: string;
	offset?: string;
}